import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const environmentsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    EntityContentBlueprint.make({
      name: 'collaborators',
      params: {
        path: '/collaborators',
        title: 'Collaborators',
        filter: entity =>
          ['component', 'resource'].includes(entity.kind.toLowerCase()),
        loader: async () => {
          const { EntityCollaboratorsContent } = await import(
            './EntityCollaboratorsContent'
          );
          return <EntityCollaboratorsContent />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'environment-tools',
      params: {
        path: '/tools',
        title: 'Tools',
        filter: entity =>
          ['component', 'resource'].includes(entity.kind.toLowerCase()),
        loader: async () => {
          const { EntityToolsContent } = await import('./EntityToolsContent');
          return <EntityToolsContent />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'environments-servers',
      params: {
        path: '/environments',
        title: 'Environments & Servers',
        filter: entity =>
          ['component', 'resource'].includes(entity.kind.toLowerCase()),
        loader: async () => {
          const { EntityEnvironmentsContent } = await import(
            './EntityEnvironmentsContent'
          );
          return <EntityEnvironmentsContent />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'audit-log',
      params: {
        path: '/audit-log',
        title: 'Audit log',
        filter: entity =>
          ['component', 'resource'].includes(entity.kind.toLowerCase()),
        loader: async () => {
          const { EntityAuditLogContent } = await import(
            './EntityAuditLogContent'
          );
          return <EntityAuditLogContent />;
        },
      },
    }),
  ],
});
